import React from "react"
import classnames from "classnames"
import {
  Space,
  H5,
  Interactive,
  LoadingIcon,
  InfoIcon,
  StarIcon,
  InputCheckBox,
  AddressIcon,
  Visible,
  Section,
  A,
  Button,
  Caption,
  Content,
  P,
  Modal
} from "AtomicComponents"
import { Tabs, Disclaimer, HeroContent, Image } from "AtomicContainers"
import componentParser from "AtomicUtils/componentParser"
import cookieHandler from "AtomicUtils/cookieHandler"
import urlHandler from "AtomicUtils/urlHandler"
import gtmHandler from "AtomicUtils/gtmHandler"
import { dispatchEvent, createNewEvent } from 'AtomicUtils/newEvent'
import { WINDOW } from "AtomicUtils/environment"
import styles from "./GradePicker.less"
import { fromLinkInputs, formSetDefaultValues } from "AtomicUtils/formHandler"

class GradePicker extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      loading: true,
      form: {
        safetyModel: {
          validations: { }
        },
        safetyModelMobile: {
          validations: {}
        }
      }
    }

    // First Tab is bodyStyle
    const activeIndexFirstTab = this._findingActiveFirstTabIndex()
    this.state.activeIndexFirstTab = activeIndexFirstTab

    const firstTabOptions = this._findingFirstTabOptions()
    this.state.firstTabOptions = firstTabOptions

    // Second Tab is driveTrain

    const secondTabOptions = this._findingSecondTabOptions()
    this.state.secondTabOptions = secondTabOptions

    const activeIndexSecondTab = this._findingActiveSecondTabIndex()
    this.state.activeIndexSecondTab = activeIndexSecondTab

    // Third Tab is grade
    const thirdTabOptions = this._findingThirdTabOptions()
    this.state.thirdTabOptions = thirdTabOptions

    const activeIndexThirdTab = this._findingActiveThirdTabIndex()
    this.state.activeIndexThirdTab = activeIndexThirdTab

    this.state.locationState = ""
  }
  //new cookieHandler().getCookie("state")
  componentDidMount() {
    this.setState({
      locationState: 'Act'
    })

    // pre-selecting based on queryParams
    setTimeout(() => {
      const currentURL = new urlHandler(WINDOW.location.href)

      const { firstTabOptions, activeIndexFirstTab } = this.state
      let firstTabIndex = activeIndexFirstTab
      if (currentURL.query.bodyStyle) {
        firstTabIndex = firstTabOptions.findIndex(
          item => item.name === currentURL.query.bodyStyle
        )
      }
      this._handleClickOnFirstTab(firstTabIndex, () => {
        const { secondTabOptions, activeIndexSecondTab } = this.state
        let secondTabIndex = activeIndexSecondTab
        if (currentURL.query.bodyStyle) {
          secondTabIndex = secondTabOptions.findIndex(
            item => item.name === currentURL.query.drivetrain
          )
        }
        this._handleClickOnSecondTab(secondTabIndex, () => {
          const { thirdTabOptions, activeIndexThirdTab } = this.state
          let thirdTabIndex = activeIndexThirdTab
          if (currentURL.query.bodyStyle) {
            thirdTabIndex = thirdTabOptions.findIndex(
              item => item.name === currentURL.query.grade
            )
          }
          this._handleClickOnThirdTab(thirdTabIndex, () => {
            this.setState({
              loading: false
            })
          }, true)
        }, false)
      }, false)
    }, 10)

    WINDOW.addEventListener(
      "POSTCODE_UPDATE",
      () => this._updatePrice(),
      false
    )
  }

  // there is a scenario to update the price after changing the postcode
  // POSTCODE_UPDATE fires in location-async at the moment
  _updatePrice = () => {
    //new cookieHandler().getCookie("state") - remove in order to have a hard coded value for NZ
    this.setState(
      {
        locationState: 'ACT'
      },
      () => {
        this.setState(
          {
            thirdTabOptions: this._findingThirdTabOptions()
          },
          this._handleOnChange
        )
      }
    )
  }

  _findingActiveFirstTabIndex = () => {
    const { data } = this.props
    let activeIndexFirstTab = 0
    if (data && data.children && data.children.length > 0) {
      if (data.children.length === 1) {
        activeIndexFirstTab = 0
      } else {
        data.children.forEach((item, index) => {
          if (item.default) {
            activeIndexFirstTab = index
          }
        })
      }
    }
    return activeIndexFirstTab
  }

  _findingFirstTabOptions = () => {
    const { data } = this.props
    if (data && data.children && data.children && data.children.length > 0) {
      return data.children.map(item => {
        let option = {}
        option.name = item.name
        return option
      })
    }
    return null
  }

  _findingActiveSecondTabIndex = () => {
    const { data } = this.props
    const { activeIndexFirstTab } = this.state
    let activeIndexSecondTab = 0
    if (
      data &&
      data.children &&
      data.children[activeIndexFirstTab].children &&
      data.children[activeIndexFirstTab].children.length > 0
    ) {
      if (data.children[activeIndexFirstTab].children.length === 1) {
        activeIndexSecondTab = 0
      } else {
        data.children[activeIndexFirstTab].children.forEach((item, index) => {
          if (item.default) {
            activeIndexSecondTab = index
          }
        })
      }
    }
    return activeIndexSecondTab
  }

  _findingSecondTabOptions = () => {
    const { data } = this.props
    const { activeIndexFirstTab } = this.state
    if (
      data &&
      data.children &&
      data.children[activeIndexFirstTab] &&
      data.children[activeIndexFirstTab].children &&
      data.children[activeIndexFirstTab].children.length > 0
    ) {
      return data.children[activeIndexFirstTab].children.map(item => {
        let option = {}
        option.name = item.name
        return option
      })
    }
    return null
  }

  _findingActiveThirdTabIndex = () => {
    const { activeIndexFirstTab, activeIndexSecondTab } = this.state
    const { data } = this.props
    let activeIndexThirdTab = 0
    if (data && data.children && data.children && data.children.length > 0) {
      if (
        data.children[activeIndexFirstTab] &&
        data.children[activeIndexFirstTab].children &&
        data.children[activeIndexFirstTab].children[activeIndexSecondTab] &&
        data.children[activeIndexFirstTab].children[activeIndexSecondTab]
          .children &&
        data.children[activeIndexFirstTab].children[activeIndexSecondTab]
          .children.length > 0
      ) {
        data.children[activeIndexFirstTab].children[
          activeIndexSecondTab
        ].children.forEach((item, index) => {
          if (item.default) {
            activeIndexThirdTab = index
          }
        })
      }
    }
    return activeIndexThirdTab
  }

  _findingThirdTabOptions = () => {
    const { activeIndexFirstTab, activeIndexSecondTab, locationState, form } = this.state
    let thirdTabOptions = null
    const { data, safetyModelExcess, safetyModelDisclaimer, gtm } = this.props
    if (data && data.children && data.children && data.children.length > 0) {
      if (
        data.children[activeIndexFirstTab] &&
        data.children[activeIndexFirstTab].children &&
        data.children[activeIndexFirstTab].children[activeIndexSecondTab] &&
        data.children[activeIndexFirstTab].children[activeIndexSecondTab]
          .children &&
        data.children[activeIndexFirstTab].children[activeIndexSecondTab]
          .children.length > 0
      ) {
        thirdTabOptions = data.children[activeIndexFirstTab].children[
          activeIndexSecondTab
        ].children.map(item => {
          // finding price in item.price
          let option = {}
          let rightItemBasedOnState = {}
          option.name = item.name

          if (locationState && item.price && item.price.length > 0) {
            rightItemBasedOnState =
            item.price[
              item.price.findIndex(
                priceItem =>
                priceItem.state.toLowerCase() ===
                locationState.toLowerCase()
                )
              ]
            if (rightItemBasedOnState && rightItemBasedOnState.price) {
              option.price = rightItemBasedOnState.price.toLocaleString()

              option.extraLabel = (
                <A
                  withoutStyle
                  onClick={(event) => {
                    if (event && event.target && event.target.querySelector('button')){
                      event.target.querySelector('button').click()
                    }
                  }}
                >
                  <Caption>From</Caption> <span className={classnames({
                    [styles.Price]: true
                  })}>${(form.safetyModel.value || form.safetyModelMobile.value) && rightItemBasedOnState.safetyModelPrice ? rightItemBasedOnState.safetyModelPrice.toLocaleString() : rightItemBasedOnState.price.toLocaleString()}
                  <Disclaimer
                    Icon={StarIcon}
                    gtm={{
                      category: gtm && gtm.category ? gtm.category : `Nameplates - ${this.props.nameplate}`,
                      action: `${gtm && gtm.action ? gtm.action : "Grade Picker"} - Clicked "PRICE" - "${item.name.toUpperCase()}"`
                    }}>
                    {rightItemBasedOnState.disclaimer}
                  </Disclaimer></span>
                </A>
              )

              option.hasSafetyModelOption = !!rightItemBasedOnState.safetyModelPrice

              option.safetyModelExcess =
                rightItemBasedOnState.safetyModelPrice && safetyModelExcess ? (
                  rightItemBasedOnState.price === rightItemBasedOnState.safetyModelPrice ?
                  <label>Included as standard</label> :
                  <A
                    withoutStyle
                    onClick={(event) => {
                      if (event && event.target && event.target.querySelector('button')){
                        event.target.querySelector('button').click()
                      }
                    }}
                  >
                    <Caption>
                      +${safetyModelExcess.toLocaleString()}
                      <Disclaimer
                        Icon={StarIcon}
                        gtm={{
                          category: gtm && gtm.category ? gtm.category : `Nameplates - ${this.props.nameplate}`,
                          action: `${gtm && gtm.action ? gtm.action : "Grade Picker"} - Clicked "SAFETY MODEL PRICE" - "${item.name.toUpperCase()}"`
                        }}>
                        {safetyModelDisclaimer}
                      </Disclaimer>
                    </Caption>
                  </A>
                ) : null

              option.isSafetyModel = rightItemBasedOnState.price && rightItemBasedOnState.safetyModelPrice && rightItemBasedOnState.price === rightItemBasedOnState.safetyModelPrice
            }
          }
          if (item.imageSrc) option.imageSrc = item.imageSrc
          if (item.featuresHeading) option.featuresHeading = item.featuresHeading
          if (item.features) option.features = item.features

          return option
        })
      }
    }
    return thirdTabOptions
  }

  _handleClickOnFirstTab = (activeIndexFirstTab, callback = () => {}, callOnChange = true ) => {
    this.setState(
      {
        activeIndexFirstTab: activeIndexFirstTab
      },
      () => {
        this.setState(
          {
            secondTabOptions: this._findingSecondTabOptions()
          },
          () => {
            this.setState(
              {
                activeIndexSecondTab: this._findingActiveSecondTabIndex()
              },
              () => {
                this.setState(
                  {
                    thirdTabOptions: this._findingThirdTabOptions()
                  },
                  () => {
                    this.setState(
                      {
                        activeIndexThirdTab: this._findingActiveThirdTabIndex()
                      },
                      () => {
                        const { gtm } = this.props
                        const { firstTabOptions, activeIndexFirstTab } = this.state

                        callback()
                        if (callOnChange) {
                          this._handleOnChange()

                          if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
                            gtmHandler({
                              pageCategory: gtm.category,
                              pageAction: `${gtm.action} - Clicked "${firstTabOptions[activeIndexFirstTab].name}"`
                            })
                          }
                        }
                      }
                    )
                  }
                )
              }
            )
          }
        )
      }
    )
  }

  _handleClickOnSecondTab = (activeIndexSecondTab, callback = () => {}, callOnChange = true ) => {
    this.setState(
      {
        activeIndexSecondTab: activeIndexSecondTab
      },
      () => {
        this.setState(
          {
            thirdTabOptions: this._findingThirdTabOptions()
          },
          () => {
            this.setState(
              {
                activeIndexThirdTab: this._findingActiveThirdTabIndex()
              },
              () => {
                const { gtm } = this.props
                const { secondTabOptions, activeIndexSecondTab } = this.state

                callback()
                if (callOnChange) {
                  this._handleOnChange()

                  if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
                    gtmHandler({
                      pageCategory: gtm.category,
                      pageAction: `${gtm.action} - Clicked "${secondTabOptions[activeIndexSecondTab].name}"`
                    })
                  }
                }
              }
            )
          }
        )
      }
    )
  }

  _handleClickOnThirdTab = (activeIndexThirdTab, callback = () => {}, callOnChange = true ) => {
    this.setState(
      {
        activeIndexThirdTab: activeIndexThirdTab
      },
      () => {
        const { gtm } = this.props
        const { thirdTabOptions, activeIndexThirdTab } = this.state

        callback()
        if (callOnChange) {
          this._handleOnChange()

          if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
            gtmHandler({
              pageCategory: gtm.category,
              pageAction: `${gtm.action} - Clicked "${thirdTabOptions[activeIndexThirdTab].name}"`
            })
          }
        }
      }
    )
  }

  _handleOnChange = () => {
    // We call On Change for Specification Block
    const { onChange = () => {}, name, data } = this.props
    const {
      activeIndexFirstTab,
      firstTabOptions,
      secondTabOptions,
      activeIndexSecondTab,
      activeIndexThirdTab,
      thirdTabOptions
    } = this.state

    // Reset safety model to default on tab change
    formSetDefaultValues(this, {
      safetyModel: thirdTabOptions[activeIndexThirdTab] && thirdTabOptions[activeIndexThirdTab].isSafetyModel || false,
      safetyModelMobile: thirdTabOptions[activeIndexThirdTab] && thirdTabOptions[activeIndexThirdTab].isSafetyModel || false
    })

    if (onChange && typeof onChange === "function") {
      if (
        firstTabOptions[activeIndexFirstTab] &&
        firstTabOptions[activeIndexFirstTab].name &&
        secondTabOptions[activeIndexSecondTab] &&
        secondTabOptions[activeIndexSecondTab].name &&
        thirdTabOptions[activeIndexThirdTab] &&
        thirdTabOptions[activeIndexThirdTab].name
      ) {
        onChange({
          bodystyle: firstTabOptions[activeIndexFirstTab].name,
          drivetrain: secondTabOptions[activeIndexSecondTab].name,
          grade: thirdTabOptions[activeIndexThirdTab].name,
          nameplate: data.name
        })
      }
    }
  }

  _renderFirstTab = () => {
    const { firstTabOptions, activeIndexFirstTab } = this.state
    return (
      <div>
        {firstTabOptions &&
          firstTabOptions.length > 0 && (
            <Tabs
              scrolling
              activeIndex={activeIndexFirstTab}
              onClick={this._handleClickOnFirstTab}
              options={firstTabOptions.map(item => {
                return {
                  name: item.name
                }
              })}
              divider
            />
          )}
      </div>
    )
  }

  _renderSecondTab = () => {
    const { secondTabOptions, activeIndexSecondTab } = this.state
    return (
      <div>
        {secondTabOptions &&
          secondTabOptions.length > 0 && (
            <Tabs
              scrolling
              activeIndex={activeIndexSecondTab}
              onClick={this._handleClickOnSecondTab}
              options={secondTabOptions.map(item => {
                return {
                  name: item.name
                }
              })}
              divider
            />
          )}
      </div>
    )
  }

  _renderThirdTabScreen = () => {
    const {
      thirdTabOptions,
      activeIndexFirstTab,
      activeIndexThirdTab
    } = this.state
    return (
      <div>
        {thirdTabOptions &&
          thirdTabOptions.length > 0 && (
            <Tabs
              scrolling
              key={`ThirdTab-${activeIndexFirstTab}`}
              activeIndex={activeIndexThirdTab}
              onClick={this._handleClickOnThirdTab}
              options={thirdTabOptions.map(({ name }) => ({ name }))}
              animatedLine
            />
          )}
      </div>
    )
  }

  _renderThirdTabTablet = () => {
    const {
      thirdTabOptions,
      activeIndexFirstTab,
      activeIndexThirdTab
    } = this.state
    return (
      <div>
        {thirdTabOptions &&
          thirdTabOptions.length > 0 && (
            <Tabs
              manualScroll
              animatedLine
              key={`ThirdTab-${activeIndexFirstTab}`}
              activeIndex={activeIndexThirdTab}
              onClick={this._handleClickOnThirdTab}
            >
              {
                thirdTabOptions.map(item => {
                  return (
                    <div
                      key={item.name}
                      className={classnames({
                        [styles.ThirdTab]: true
                      })}>
                      <Interactive withDetails>{item.name}</Interactive>
                      <br/>
                      {item.price && <Caption>{`From $${item.price}`}</Caption>}
                      <div className={classnames({
                        [styles.ThirdTabImage]: true
                      })}>
                        <Image src={`${item.imageSrc}?width=240`} />
                      </div>
                    </div>
                  )
                })
              }
            </Tabs>
          )}
      </div>
    )
  }

  _renderCommonFeaturesArea = (mobile = false) => {
    const { safetyModelBlurb, fullSpecCta, data, onChange = () => { }, gtm } = this.props
    const { firstTabOptions, activeIndexFirstTab, secondTabOptions, activeIndexSecondTab, thirdTabOptions, activeIndexThirdTab, locationState, loading, form } = this.state
    const activeGrade = thirdTabOptions[activeIndexThirdTab]
    return (
      <div
        className={classnames({
          [styles.Features]: true
        })}>
        <div className={classnames({
          [styles.FeatureSingle]: true,
          [styles.FeatureLine]: true
        })}>
          <H5 withDetails>{activeGrade.name}</H5>
          {
            loading ?
            <LoadingIcon
              style={{
                width: "16px",
                height: "16px"
              }}
            />
            :
            activeGrade.extraLabel
          }
        </div>
        {
          !locationState &&
          <div className={classnames({
            [styles.FeatureSingle]: true,
            [styles.FeatureLine]: true
          })}>
            {this._renderPostcodePrompt()}
          </div>
        }
        {
          locationState &&
          activeGrade.safetyModelExcess &&
          activeGrade.hasSafetyModelOption &&
          <div className={classnames({
            [styles.FeatureSingle]: true,
            [styles.FeatureLine]: true
          })}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <InputCheckBox
                key={`VT-${activeGrade.name}`}
                name="vision"
                label="Vision Technology"
                checked={activeGrade.isSafetyModel}
                disabled={activeGrade.isSafetyModel}
                {...fromLinkInputs(this, `safetyModel${mobile ? 'Mobile' : ''}`, (value) => {
                  this.setState({
                    loading: false,
                    thirdTabOptions: this._findingThirdTabOptions()
                  }, () => {
                    if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "" && (value || form[`safetyModel${mobile ? 'Mobile' : ''}`].value)) {
                      gtmHandler({
                        pageCategory: gtm.category,
                        pageAction: `${gtm.action} - ${value ? "Checked" : "Unchecked"} "SAFETY MODEL"`
                      })
                    }
                    if (onChange && typeof onChange === "function") {
                      onChange({
                        bodystyle: firstTabOptions[activeIndexFirstTab].name,
                        drivetrain: secondTabOptions[activeIndexSecondTab].name,
                        grade: thirdTabOptions[activeIndexThirdTab].name,
                        nameplate: data.name,
                        isSafetyModel: !!this.state.form[`safetyModel${mobile ? 'Mobile' : ''}`].value
                      })
                    }
                  })
                })}
              />
              <span
                onClick={() => {
                  this.setState({ isModalOpen: true }, () => {
                    if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
                      gtmHandler({
                        pageCategory: gtm.category,
                        pageAction: `${gtm.action} - Opened "SAFETY MODEL" modal`
                      })
                    }
                  })
                }}>
                <InfoIcon style={{
                  height: "16px",
                  width: "16px",
                  fill: "#999999",
                  paddingLeft: "6px",
                  cursor: "pointer",
                  verticalAlign: "middle"
                }} />
              </span>
            </div>
            <div>{activeGrade.safetyModelExcess}</div>
          </div>
        }
        {
          this.state.isModalOpen &&
          <Modal
            width="600px"
            handleClose={() => {
              this.setState({ isModalOpen: false })
            }}>
            <Content xmlString={safetyModelBlurb} textAlign="left" />
            <Button
              styleName="black"
              onClick={() => {
                this.setState({ isModalOpen: false })
              }}>
              Close
            </Button>
          </Modal>
        }
        <Space />
        <Content textAlign="left">
          <label><b>
            {
              activeGrade.featuresHeading ?
              activeGrade.featuresHeading :
              (thirdTabOptions.length === 1 ||
              activeIndexThirdTab === 0 ||
              thirdTabOptions.length === activeIndexThirdTab - 1) ?
              "Base features:" :
              `In addition to ${thirdTabOptions[activeIndexThirdTab - 1].name}:`
            }
          </b></label>
          <ul>
            {activeGrade.features.map((item, index) => (
              <li
                key={`Featuer-${index}`}
                className={classnames({
                  [styles.FeatureSingle]: true
                })}>
                <Caption>{item.description}</Caption>
              </li>
            ))}
          </ul>
        </Content>
        {
          fullSpecCta &&
          fullSpecCta.href &&
          <P>
            <A styleName="black" onClick={this._handleClickOnViewSpecification}>
              <Caption>{fullSpecCta.label || 'View full specs >'}</Caption>
            </A>
          </P>
        }
      </div>
    )
  }

  _renderCommonButtons = () => {
    const { fullSpecCta, components } = this.props
    return (
      <div
        className={classnames({
          [styles.Buttons]: true
        })}>
        {componentParser(components)}
      </div>
    )
  }

  _handleClickOnViewSpecification = () => {
    const { fullSpecCta } = this.props
    const {
      firstTabOptions,
      secondTabOptions,
      thirdTabOptions,
      activeIndexFirstTab,
      activeIndexSecondTab,
      activeIndexThirdTab
    } = this.state
    let newSpecsUrl = fullSpecCta.href
    newSpecsUrl =
      newSpecsUrl +
      `?bodyStyle=${encodeURIComponent(
        firstTabOptions[activeIndexFirstTab].name
      )}`
    newSpecsUrl =
      newSpecsUrl +
      `&drivetrain=${encodeURIComponent(
        secondTabOptions[activeIndexSecondTab].name
      )}`
    newSpecsUrl =
      newSpecsUrl +
      `&grade=${encodeURIComponent(thirdTabOptions[activeIndexThirdTab].name)}`

    if (fullSpecCta.gtm && fullSpecCta.gtm.category && fullSpecCta.gtm.action && fullSpecCta.gtm.category !== "" && fullSpecCta.gtm.action !== "") {
      gtmHandler({
        pageCategory: fullSpecCta.gtm.category,
        pageAction: fullSpecCta.gtm.action
      })
    }

    setTimeout(() => {
      new urlHandler(newSpecsUrl).redirect(true)
    }, 200)
  }

  _handleOpenPostcodePopup = () => {
    setTimeout(() => {

      let event = createNewEvent('POSTCODE_POPUP_OPEN')
      dispatchEvent(event)
    }, 100)
  }

  _renderPostcodePrompt = () => {
    return (
      <div>
        <AddressIcon style={{ height: "16px", width: "16px", margin: "0 4px -4px 0", fill: "#910A2D" }} />
        <A onClick={this._handleOpenPostcodePopup}><Caption>Enter postcode for pricing</Caption></A>
      </div>
    )
  }

  render() {
    const { heading, description } = this.props
    const {
      thirdTabOptions,
      activeIndexThirdTab,
      firstTabOptions,
      secondTabOptions,
    } = this.state

    return (
      <div
        data-test="grade-picker"
        className={classnames({
          [styles.GradePicker]: true
        })}>
        <Space />
        { (heading || description) &&
          <HeroContent
            heading={heading}
            description={description}
          />
        }
        <div>
          <Visible visible={["screen", "tablet", "mobile"]}>
            <div className={classnames({
              [styles.TabsContainer]: true
            })}>
              {
                firstTabOptions &&
                firstTabOptions.length > 1 &&
                secondTabOptions &&
                secondTabOptions.length === 1 &&
                this._renderFirstTab()}

              {
                secondTabOptions &&
                secondTabOptions.length > 1 &&
                firstTabOptions &&
                firstTabOptions.length === 1 &&
                this._renderSecondTab()}

              {
                firstTabOptions &&
                firstTabOptions.length > 1 &&
                secondTabOptions &&
                secondTabOptions.length > 1 && (
                  <div
                    className={classnames({
                      [styles.GradePickerTwoTabs]: true
                    })}>
                    {this._renderFirstTab()}
                    <span
                      className={classnames({
                        [styles.Span]: true
                      })}>
                      {" "}
                      /{" "}
                    </span>
                    {this._renderSecondTab()}
                  </div>
                )}
            </div>
          </Visible>
        </div>

        <div>
          <Visible visible={["screen"]}>
            <div className={classnames({
              [styles.TabsContainer]: true
            })}>
              {/* {this._renderThirdTabScreen()} */}
              <Space />
              {this._renderThirdTabTablet()}
            </div>
          </Visible>
        </div>

        <div>
          <Visible visible={["tablet", "mobile"]}>
            <div className={classnames({
              [styles.TabsContainer]: true
            })}>
              {this._renderThirdTabTablet()}
              <Space />
            </div>
          </Visible>
        </div>

        <Visible visible={["screen", "tablet", "mobile"]}>
          <Section sizeName="screen" gutter>
            {thirdTabOptions &&
              thirdTabOptions.length > 0 &&
              thirdTabOptions[activeIndexThirdTab] &&
              thirdTabOptions[activeIndexThirdTab].features && (
                <div
                  className={classnames({
                    [styles.ImageFeaturesParent]: true
                  })}>
                  <div
                    className={classnames({
                      [styles.ImageFeatures]: true
                    })}>
                    <div
                      className={classnames({
                        [styles.Image]: true
                      })}>
                      <img src={thirdTabOptions[activeIndexThirdTab].imageSrc} />
                    </div>

                    {this._renderCommonFeaturesArea()}
                  </div>

                  {this._renderCommonButtons()}
                </div>
              )}
          </Section>
        </Visible>
      </div>
    )
  }
}

export default GradePicker



// WEBPACK FOOTER //
// ./src/AtomicContainers/GradePicker/GradePicker.jsx